module.exports = __webpack_public_path__ + "static/media/activitiesBackground.b4dd3236.png";